import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import dos_and_donts_blog_img from "../../Assets/dos_and_donts_blog_img.webp";
import "./blog.css";
import "animate.css";
import { Link } from "react-router-dom";

function Dos_and_donts_for_your_first_hydroponic_crop_cycle() {
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowImage(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container fluid>
      <div className="d-flex justify-content-center">
        <img
          src={dos_and_donts_blog_img}
          className={`card-img-top img-fluid p-3 rounded animate__animated animate__fadeInDown ${
            showImage ? "show" : ""
          }`}
          style={{ width: "70%" }}
          alt="Do's and Don'ts of first hydroponic crop cycle"
        />
      </div>
      <Row className="m-3 m-md-5">
        <Col
          className="p-3 textJustify"
          sm={12}
          md={9}
          xs={12}
          style={{ fontSize: "1rem", lineHeight: "1.6" }}
          id="content"
        >
          <div id="blog1" className="border p-2">
            <h1 className="text-center p-3">
              Do’s and Don’ts for Your First Hydroponic Crop Cycle
            </h1>
            <p>
              Starting your first hydroponic crop cycle is exciting—but it can
              also be overwhelming. Unlike traditional farming, hydroponics is a
              highly controlled, technical growing method. The right decisions
              early on can make your system productive and profitable. The wrong
              ones can lead to crop failure, wasted investment, and frustration.
            </p>
            <p>
              To help you succeed from Day 1, here are some practical do’s and
              don’ts based on real farm experience and best practices.
            </p>
            <p>
              <h2 className="fw-bold">
                DO’S: What You Should Do in Your First Crop Cycle
              </h2>
              <p>
                <ol>
                  <li>
                    <span className="fw-bold">
                      Do Start with Easy-to-Grow Crops
                    </span>
                    <p>
                      Begin with fast-growing, low-maintenance crops like:
                      <ul>
                        <li>Lettuce</li>

                        <li>Basil</li>

                        <li>Spinach</li>

                        <li>Mint</li>

                        <li>Coriander</li>
                      </ul>
                      These crops are more forgiving and help you understand
                      your system before you try complex crops like tomatoes or
                      strawberries.
                    </p>
                  </li>
                  <li>
                    <span className="fw-bold">
                      Do Monitor EC and pH Regularly
                    </span>
                    <p>
                      Your plants feed directly from water, so:
                      <ul>
                        <li>Keep pH between 5.5–6.5 depending on crop</li>

                        <li>
                          Maintain EC (Electrical Conductivity) as per plant
                          type and stage
                        </li>
                      </ul>
                      Use a digital EC/pH meter and record readings daily. This
                      small habit will prevent major nutrient issues.
                    </p>
                  </li>
                  <li>
                    <span className="fw-bold">
                      Do Use Clean, RO or Filtered Water
                    </span>
                    <p>
                      Water quality is critical. High TDS, salt, or chemical
                      content can harm roots. Ideally:
                      <ul>
                        <li>Use RO water or filtered borewell water</li>
                        <li>Check water for TDS 300 ppm</li>
                      </ul>
                      Poor water can ruin an entire crop cycle, especially in
                      NFT or DWC systems.
                    </p>
                  </li>
                  <li>
                    <span className="fw-bold">
                      Do Maintain Good Air Circulation
                    </span>
                    <p>
                      Stagnant air = humidity buildup = fungal diseases.
                      <br></br>Ensure:
                      <ul>
                        <li>
                          Proper ventilation (especially in naturally ventilated
                          polyhouses)
                        </li>

                        <li>Use of exhaust fans and oscillating fans</li>

                        <li>Regular pruning of dense crops for airflow</li>
                      </ul>
                    </p>
                  </li>
                  <li>
                    <span className="fw-bold">Do Stagger Your Planting</span>
                    <p>
                      Don’t plant everything on the same day. Instead, stagger
                      planting over 5–7 days. This gives you:
                      <ul>
                        <li>A continuous harvest window</li>

                        <li>
                          Time to manage tasks like transplanting, nutrient
                          adjustments, and harvesting
                        </li>
                      </ul>
                    </p>
                  </li>
                  <li>
                    <span className="fw-bold">Do Keep Your System Clean</span>
                    <p>
                      <ul>
                        <li>Clean tanks and pipelines weekly</li>

                        <li>Sterilize tools</li>

                        <li>Flush nutrient lines every 7–10 days</li>

                        <li>Disinfect trays between batches</li>
                      </ul>
                      Cleanliness prevents algae, root rot, and
                      cross-contamination.
                    </p>
                  </li>
                  <li>
                    <span className="fw-bold">Do Learn From Each Cycle</span>
                    <p>
                      Keep a simple logbook or digital file for:
                      <ul>
                        <li>Nutrient mixes</li>

                        <li>pH/EC fluctuations</li>

                        <li>Disease/pest issues</li>

                        <li>Growth time</li>
                      </ul>
                      This will help improve every future cycle.
                    </p>
                  </li>
                </ol>
              </p>
              <p>
                <h2 className="fw-bold">
                  DON’TS: Mistakes to Avoid in Your First Hydroponic Cycle
                </h2>
                <ol>
                  <li>
                    <span className="fw-bold">
                      Don’t Overfeed or Overmix Nutrients
                    </span>
                    <p>
                      More nutrients ≠ better growth.<br></br>Overfeeding leads
                      to:
                      <ul>
                        <li>Nutrient lockout</li>

                        <li>Root burn</li>

                        <li>Poor plant health</li>
                      </ul>
                      Stick to crop-specific guidelines and always dissolve
                      nutrients fully before mixing into the main tank.
                    </p>
                  </li>
                  <li>
                    <span className="fw-bold">
                      Don’t Skip Water Quality Testing
                    </span>
                    <p>
                      Neglecting this is a common beginner mistake.
                      <ul>
                        <li>
                          Hard water or high chlorine can kill beneficial
                          microbes or damage roots
                        </li>

                        <li>
                          Get your water tested at least once before starting
                          your first cycle
                        </li>
                      </ul>
                    </p>
                  </li>
                  <li>
                    <span className="fw-bold">
                      Don’t Transplant Weak or Stressed Seedlings
                    </span>
                    <p>
                      Only transplant healthy, well-rooted seedlings. If they:
                      <ul>
                        <li>Have yellow leaves</li>

                        <li>Are too tall and thin (leggy)</li>

                        <li>Show signs of mold</li>
                      </ul>
                      don’t put them into your main system. They’ll delay the
                      crop and invite pests.
                    </p>
                  </li>
                  <li>
                    <span className="fw-bold">
                      Don’t Ignore Pest Control Thinking It’s Pest-Free
                    </span>
                    <p>
                      Hydroponic doesn’t mean pest-proof.<br></br>Watch out for:
                      <ul>
                        <li>Whiteflies</li>

                        <li>Aphids</li>

                        <li>Thrips</li>

                        <li>Leaf miners</li>
                      </ul>
                      Use netting, yellow sticky traps, and neem oil spray
                      preventively.
                    </p>
                  </li>
                  <li>
                    <span className="fw-bold">Don’t Let Your Tank Run Dry</span>
                    <p>
                      Low water = pump damage + root drying.
                      <ul>
                        <li>Install water level sensors</li>

                        <li>Keep backup water ready</li>

                        <li>
                          Monitor nutrient tank daily (especially in summer)
                        </li>
                      </ul>
                    </p>
                  </li>

                  <li>
                    <span className="fw-bold">
                      Don’t Assume One Formula Fits All Crops
                    </span>
                    <p>
                      Each crop and even crop stage needs a different nutrient
                      ratio. For example:
                      <ul>
                        <li>Lettuce seedlings need low EC (0.8–1.2)</li>

                        <li>
                          Fruiting tomatoes need high potassium during flowering
                        </li>
                      </ul>
                      Use stage-wise nutrient charts and consult experts when
                      unsure.
                    </p>
                  </li>

                  <li>
                    <span className="fw-bold">Don’t Skip Backup Power</span>
                    <p>
                      A few hours of power failure can:
                      <ul>
                        <li>Kill plants</li>

                        <li>Stop water circulation</li>
                        <li>Raise temperatures dangerously</li>
                      </ul>
                      Install an inverter or generator, especially if you're
                      using fan & pad polyhouse systems.
                    </p>
                  </li>
                </ol>
                Your first hydroponic crop cycle is your learning ground. Don’t
                chase perfection. Instead, focus on building habits:
                <ul>
                  <li>Monitoring</li>

                  <li>Cleaning</li>

                  <li>Observing plant signals</li>

                  <li>Documenting</li>
                </ul>
                Make it a learning process rather than a race. With time and
                experience, your crop quality, yield, and confidence will all
                improve.
              </p>
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Dos_and_donts_for_your_first_hydroponic_crop_cycle;
